import React from 'react';

export const ArrowImage = () => {
  return (
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 13L1 6.98742L7 1" stroke="#33894E" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};
